import {
    LIST_USERS,
    LIST_USERS_SUCCESS,
    LIST_USERS_FAILURE,
    CREATE_USER,
    UPDATE_USER,
    DELETE_USER,
    // UPDATE_CHANGE_PASSWORD_FORM,
    // RESET_CHANGE_PASSWORD_FORM,
    OPEN_CREATE_DIALOG,
    OPEN_UPDATE_DIALOG,
    CLOSE_DIALOGS,
    CHANGE_PASSWORD,
    CREATE_USER_SUCCESS, CREATE_USER_FAILURE, UPDATE_USER_FAILURE, UPDATE_USER_SUCCESS,
    // CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE,
    DELETE_USER_SUCCESS, DELETE_USER_FAILURE,
    RESET_USER_PASSWORD, RESET_USER_PASSWORD_SUCCESS, RESET_USER_PASSWORD_FAILURE,
} from './UsersActionTypes';
import {errorMessage} from "../../../components/AjaxHelpers";

export const createUser = (userForm) => ({
    type: CREATE_USER,
    userForm,
})
export const createUserSucceeded = () => ({
    type: CREATE_USER_SUCCESS,
})
export const createUserFailed = (error) => ({
    type: CREATE_USER_FAILURE,
    message: errorMessage(error, 'Fel vid försök att skapa användare'),
})

export const updateUser = (userForm) => ({
    type: UPDATE_USER,
    userForm,
})
export const updateUserSucceeded = () => ({
    type: UPDATE_USER_SUCCESS,
})
export const updateUserFailed = (error) => ({
    type: UPDATE_USER_FAILURE,
    message: errorMessage(error,'Fel vid försök att uppdatera användare'),
})

// export const resetChangePasswordForm = () => ({
//     type: RESET_CHANGE_PASSWORD_FORM,
// })
//
// export const updateChangePasswordForm = (fieldName, fieldValue) => ({
//     type: UPDATE_CHANGE_PASSWORD_FORM,
//     fieldName,
//     fieldValue
// })

export const changePassword = (username, currentPassword, newPassword, newPasswordRetype) => ({
    type: CHANGE_PASSWORD,
    username,
    currentPassword,
    newPassword,
    newPasswordRetype,
})
// export const changePasswordSucceeded = () => ({
//     type: CHANGE_PASSWORD_SUCCESS,
// })
// export const changePasswordFailed = (error) => ({
//     type: CHANGE_PASSWORD_FAILURE,
//     message: error.response.message || 'Fel vid försök att byta lösenord',
// })

export const deleteUser = (username) => ({
    type: DELETE_USER,
    username,
})
export const deleteUserSucceeded = () => ({
    type: DELETE_USER_SUCCESS,
})
export const deleteUserFailed = (error) => ({
    type: DELETE_USER_FAILURE,
    message: errorMessage(error,'Fel vid försök att ta bort användare'),
})

export const listUsers = () => ({
    type: LIST_USERS,
})
export const listUsersSucceeded = (users) => ({
    type: LIST_USERS_SUCCESS,
    users
})
export const listUsersFailed = (error) => ({
    type: LIST_USERS_FAILURE,
    message: errorMessage(error,'Fel vid försök att lista användare'),
})

export const resetUserPassword = (username) => ({
    type: RESET_USER_PASSWORD,
    username,
})
export const resetUserPasswordSucceeded = () => ({
    type: RESET_USER_PASSWORD_SUCCESS,
})
export const resetUserPasswordFailed = (error) => ({
    type: RESET_USER_PASSWORD_FAILURE,
    message: errorMessage(error, 'Fel vid försök att återställa lösenord'),
})

export const openCreateDialog = () => ({
    type: OPEN_CREATE_DIALOG,
})

export const openUpdateDialog = (user) => ({
    type: OPEN_UPDATE_DIALOG,
    username: user.username,
    role: user.role,
    organizationId: user.organizationId,
    userForm: {
        username: user.username,
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        email: user.email || '',
        emailRepetition: user.email || '',
        role: user.role,
        organization: user.organizationId,
        password: '',
        isOrgAdmin: user.isOrgAdmin || false,
    }
})

export const closeDialogs = () => ({
    type: CLOSE_DIALOGS,
})